import { useEffect, useState } from 'react';
import { useOLMap } from '../components/MapContext';
export function useLayer(layerId) {
    const map = useOLMap();
    const layers = map.getLayers();
    const [layer, setLayer] = useState();
    useEffect(() => {
        const handleAddLayer = (e) => {
            const layer = e.element;
            if (layer.getProperties().id === layerId) {
                setLayer(layer);
            }
        };
        const layer = layers.getArray().find((layer) => layer.getProperties().id === layerId);
        if (layer) {
            setLayer(layer);
        }
        else {
            layers.on('add', handleAddLayer);
            return () => {
                layers.un('add', handleAddLayer);
            };
        }
    }, [layers, layerId]);
    return layer;
}
//# sourceMappingURL=useLayer.js.map